import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { useTranslation } from 'react-i18next';
import { FC } from 'react';
import DialogContentText from '@mui/material/DialogContentText';
import Swal from 'sweetalert2';
import { LocalizationManagementCommand } from '../../../../services/command';
import { Box, Fade, LinearProgress } from '@mui/material';

export interface LocalizationConfirmDialogE2EClasses {
    dialogPaper?: string;
    progressWrap?: string;
    dialogTitle?: string;
    dialogContent?: string;
    dialogActions?: string;
    rejectButton?: string;
    acceptButton?: string;
}

interface IProps {
    selectedRow?: any;
    open?: boolean;
    onClose?: any;
    dialogContent?: string;
    dialogTitle?: string;
    buttonNameAccept?: string;
    buttonNameReject?: string;
    closeEditModal?: any;
    setDatas?: any;
    datas?: any;
    actionType?: 'update' | 'delete' | 'fileUpload';
    updatedRow?: any;
    filterInput?: any;
    refresh?: any;
    e2eClassNames?: LocalizationConfirmDialogE2EClasses;
}
export const SCUIConfirmDialog: FC<IProps> = ({
    selectedRow,
    dialogContent,
    dialogTitle,
    buttonNameAccept,
    buttonNameReject,
    open = false,
    onClose,
    closeEditModal,
    actionType,
    updatedRow,
    filterInput,
    refresh,
    e2eClassNames: e2e,
}) => {
    const { t } = useTranslation();
    const [loading, setLoading] = React.useState<any>(false);
    const handleClose = () => {
        onClose(false);
    };
    const UpdateLocalizationItem = async () => {
        try {
            if (!loading) {
                setLoading(true);
                if (updatedRow && selectedRow) {
                    let isChange = true;
                    if (isChange) {
                        let params: any = {};
                        params.applicationIds = selectedRow.applications.map((app: any) => app.applicationId);

                        if (!selectedRow.keywords) {
                            params.keyWord = selectedRow.keyword;
                            params.Culture = filterInput.cultureCode;
                            params.value = updatedRow.keyword;

                            LocalizationManagementCommand.AddLocalizationManagement(params)
                                .then(() => {
                                    Swal.fire(t('general.added'), ' ', 'success');
                                    refresh();
                                })
                                .catch((error: any) => {
                                    console.log('Hata :>> ', error);
                                })
                                .finally(() => {});
                        } else {
                            params.keyWord = selectedRow.keyword;
                            params.cultureCodeTranslation = {
                                [filterInput.cultureCode]: updatedRow.keyword,
                            };
                            LocalizationManagementCommand.UpdateLocalizationManagement(params)
                                .then(() => {
                                    Swal.fire(t('general.updated'), ' ', 'success');
                                    refresh();
                                })
                                .catch((error: any) => {
                                    console.log('Hata :>> ', error);
                                })
                                .finally(() => {});
                        }
                    } else {
                        Swal.fire('Error', t('general.noChangeFound'), 'warning');
                    }
                } else {
                    Swal.fire('No Data Found', t('general.noDataFound'), 'error');
                }
                setLoading(false);
            }
        } catch (error: any) {
            Swal.fire('Error', error.toString(), 'error');
            setLoading(false);
        }
        closeEditModal();
        handleClose();
    };
    const DeleteLocalizationItem = async () => {
        try {
            if (!loading) {
                setLoading(true);
                if (selectedRow) {
                    LocalizationManagementCommand.DeleteLocalizationManagement(selectedRow.toString())
                        .then(() => {
                            Swal.fire(t('general.deleted'), ' ', 'success');
                            refresh();
                        })
                        .catch((error: any) => {
                            console.log('Hata :>> ', error);
                        })
                        .finally(() => {});
                } else {
                    Swal.fire('No Data Found', t('general.noDataFound'), 'error');
                }
                setLoading(false);
            }
        } catch (error: any) {
            Swal.fire(error?.data?.Message, error?.data?.Key, 'error');
            setLoading(false);
        }
        handleClose();
    };
    const confirmAcceptHandle = async () => {
        try {
            if (actionType === 'delete') {
                DeleteLocalizationItem();
            } else if (actionType === 'update') {
                UpdateLocalizationItem();
            }
        } catch (error: any) {
            Swal.fire('Error', error.toString(), 'error');
        }
    };
    return (
        <React.Fragment>
            <Dialog
                open={open}
                onClose={onClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                slotProps={{
                    paper: {
                        ...(e2e?.dialogPaper ? { className: e2e.dialogPaper } : {}),
                    },
                }}
            >
                <Box className={e2e?.progressWrap}>
                    <Fade in={loading} unmountOnExit>
                        <LinearProgress />
                    </Fade>
                </Box>
                {dialogTitle && dialogTitle != '' ? (
                    <DialogTitle className={e2e?.dialogTitle}>{dialogTitle}</DialogTitle>
                ) : (
                    <div style={{ display: 'none' }}></div>
                )}
                <DialogContent className={e2e?.dialogContent}>
                    <DialogContentText id="alert-dialog-description">{dialogContent}</DialogContentText>
                </DialogContent>
                <DialogActions className={e2e?.dialogActions}>
                    <Button className={e2e?.rejectButton} onClick={onClose}>
                        {buttonNameReject}
                    </Button>
                    <Button className={e2e?.acceptButton} onClick={confirmAcceptHandle} autoFocus>
                        {buttonNameAccept}
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
};
